/**
 * The caller's portal-request status — "Requested" while their access is still pending — read from
 * the `reqData` blob the login flow caches.
 *
 * Shared by the side nav, the Home page, Change Log, and Feature Voting (ACOP-118) — all gate on
 * the same "is this account pending" question, and disagreeing about it is exactly the bug this
 * exists to prevent (e.g. the nav hiding an item a page still renders as fully available).
 *
 * This depends on `reqData` staying in localStorage for the caller's whole session — it's a read,
 * not a consume. Do NOT `localStorage.removeItem('reqData')` after reading it anywhere in the app;
 * Copilot.tsx did exactly that on its own first mount, which silently broke every consumer here for
 * the rest of the session as soon as a user's very first navigation touched that page (virtually
 * always, since it's the universal post-login landing page — see `utils/landing.ts`).
 *
 * Returns "" for anything it cannot read (no entry, malformed JSON, storage blocked), which means
 * "not pending" — the same value a fully approved caller produces.
 */
export function readReqStatus(): string {
  try {
    const raw = localStorage.getItem("reqData");
    if (!raw) return "";
    return JSON.parse(raw).status || "";
  } catch {
    return "";
  }
}
